import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { FC } from "react";
import StubAccount from "./StubAccount";
import BotList from "./BotList";
import { AutoStrategyInfo, FuturesBotInfo } from "../types";

interface BotScreenProps {
  futuresBots: FuturesBotInfo;
  autoStrategies: AutoStrategyInfo;
}

const BotScreen: FC<BotScreenProps> = ({ futuresBots, autoStrategies }) => {
  const accounts = useSelector((state: RootState) => state.user.profile.accounts);

  return (
    <>
      {!accounts.length ? (
        <Box sx={{ paddingBottom: 2 }}>
          <StubAccount />
        </Box>
      ) : null}

      <BotList
        accounts={accounts.length}
        futuresBots={futuresBots}
        autoStrategies={autoStrategies}
      />
    </>
  );
};

export default BotScreen;
